import React from "react";

export default function Contacto() {
  return (
    <main className="w-full text-white bg-[#111618] font-display">
      {/* Mapa */}
      <section className="w-full">
        <div className="w-full h-[60vh] md:h-[70vh]">
          <iframe
            title="Ubicación TLC.MX"
            allowFullScreen
            height="100%"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3795.1129521725647!2d-102.20992512476828!3d17.973481185656613!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x84315d8d7a131d1f%3A0xf8659eae45953bce!2sTURBOS%20JRONE!5e0!3m2!1ses-419!2smx!4v1760733369983!5m2!1ses-419!2smx"
            style={{ border: 0, width: "100%", height: "100%" }}
          ></iframe>
        </div>
      </section>

      {/* Información de contacto */}
      <section className="py-16 px-4 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Visítanos</h1>
          <p className="mt-4 text-lg text-gray-400">
            Encuentra nuestra ubicación y horarios de atención.
          </p>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            {/* Dirección */}
            <div className="bg-[#1C2327] p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4 flex items-center">
                <span className="material-symbols-outlined mr-3 text-primary">location_on</span>
                Dirección
              </h3>
              <p className="text-gray-300"> Av. Las Palmas 24, Del Carmen, 60952 Cdad. Lázaro Cárdenas, Mich.</p>
            </div>
            {/* Horarios */}
            <div className="bg-[#1C2327] p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4 flex items-center">
                <span className="material-symbols-outlined mr-3 text-primary">schedule</span>
                Horarios
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <strong>Lunes a Viernes:</strong>  
                  <li>9:00 AM - 2:00 PM</li>
                   <li>4:00 PM - 6:00 PM</li>
                </li>
                <li>
                  <strong>Sábado:</strong> 
                  <li>9:00 AM - 2:00 PM</li>
                </li>
                <li>
                  <strong>Domingo:</strong> Cerrado
                </li>
              </ul>
            </div>
            {/* Contacto */}
            <div className="bg-[#1C2327] p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4 flex items-center">
                <span className="material-symbols-outlined mr-3 text-primary">contact_phone</span>
                Contacto
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="material-symbols-outlined mr-2 text-sm">call</span>
                  <span>+52 753 116 9174</span>
                </li>
                <li className="flex items-center">
                  <span className="material-symbols-outlined mr-2 text-sm">email</span>
                  <span>ventas@tlc.mx</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99 0-3.903-.52-5.687-1.475L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.447-4.435-9.884-9.888-9.884-5.448 0-9.886 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01s-.52.074-.792.372c-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"></path>
                  </svg>
                  <a
                    className="hover:text-primary"
                    href="https://wa.me/527531169174"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +52 753 116 9174
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}